import { trailerTypes } from "@/utils/constants";

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
  if (!email) {
    return false;
  } else if (!emailRegex.test(email)) {
    return false;
  }
  return true;
};

export const validateTrailerType = (trailerType) => !!trailerTypes.find((t) => t.id === trailerType);
